import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["textContent"]

import { computed } from 'vue'
import { usePageFrontmatter } from 'vuepress/client'
import type { DefaultThemeHomePageFrontmatter } from '../../shared/index.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPHomeFooter',
  setup(__props) {

const frontmatter = usePageFrontmatter<DefaultThemeHomePageFrontmatter>()

const footer = computed(() => frontmatter.value.footer)
const footerHtml = computed(() => frontmatter.value.footerHtml)

return (_ctx: any,_cache: any) => {
  return (footer.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (footerHtml.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vp-footer",
              "vp-footer": "",
              innerHTML: footer.value
            }, null, 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "vp-footer",
              "vp-footer": "",
              textContent: _toDisplayString(footer.value)
            }, null, 8, _hoisted_2))
      ], 64))
    : _createCommentVNode("", true)
}
}

})